<div *ngIf='userData && showType' class='TotalCount'>
  <div *ngIf='showInboxStatus' class='TotalCount__inbox-status container'>
    <app-info-tip-button [type]="'inbox_status'"></app-info-tip-button>
    <span
    >Current inbox status
      <fa-icon
        [icon]='iconCircle'
        [size]="'1x'"
        class='TotalCount__inbox-status__icon {{
          userData.account_status
        }}'></fa-icon
      ></span>
  </div>
  <div class='container'>
    <ng-container *ngIf="showType === 'total'">
      <p>Send: {{ totalSentToday }} of your {{ sendLimit }} daily campaign email send limit</p>
      <div class='TotalCount-trigger d-flex flex-column'>
        <div
          (click)='selectItem(item)'
          *ngFor='let item of selectProperties.items'
          [class.active]='item.value === activeItem || showAll'
          class='TotalCount-trigger-item'>
          <b>{{ item.label }}</b>
          <ng-container *ngIf='!showAll'>
            <span *ngIf='targetCount || targetCount >= 0'
            >:&nbsp;{{ targetCount }}</span
            >
            <ng-container *ngIf='targetCount === undefined'>
              &nbsp;
              <mat-spinner color='warn' diameter='20' mode='indeterminate'>
              </mat-spinner>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
